module.exports = __webpack_public_path__ + "static/dl-0f05bf1ab3887422bedf8344aa4b24de.svg";